export function registerKeyboardShortcuts({
  targetElement,
  shortcuts = [],
}) {
  if (!targetElement || !targetElement.addEventListener) {
    throw new Error("registerKeyboardShortcuts: a valid DOM element is required");
  }

  function onKeyDown(e) {
    // avoid intercepting typing in form fields
    if (["INPUT", "TEXTAREA"].includes(e.target.tagName)) return;

    const key = e.key.toLowerCase();
    const shortcut = shortcuts.find(s => s.keys.includes(key));
    if (shortcut) {
      shortcut.action(e);
      e.preventDefault();
    }
  }

  targetElement.addEventListener("keydown", onKeyDown);

  // return cleanup function
  return () => {
    targetElement.removeEventListener("keydown", onKeyDown);
  };
}